import { render } from "./App.vue?vue&type=template&id=27e00b5e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=27e00b5e&lang=less"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__